import { render } from "./ImportStudentPhotos.vue?vue&type=template&id=3c361569"
import script from "./ImportStudentPhotos.vue?vue&type=script&lang=js"
export * from "./ImportStudentPhotos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__